var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2166 57.9716L39.1957 57.9282L39.149 57.9403C36.9825 58.5063 34.7477 58.793 32.4844 58.793C17.9129 58.793 6.05859 46.9906 6.05859 32.4844C6.05859 17.9424 17.941 6.05859 32.4844 6.05859C46.9906 6.05859 58.793 17.9129 58.793 32.4844C58.793 34.7478 58.5063 36.9825 57.9403 39.149L57.9282 39.1957L57.9716 39.2166C62.6851 41.4882 65.9414 46.2843 65.9414 51.8203C65.9414 59.5611 59.5629 65.9414 51.8203 65.9414C46.2844 65.9414 41.4883 62.6851 39.2166 57.9716ZM54.6436 38.0978L54.6985 38.1089L54.712 38.0546C55.1649 36.2418 55.3945 34.375 55.3945 32.4844C55.3945 19.7873 45.1174 9.45703 32.4844 9.45703C19.787 9.45703 9.45703 19.787 9.45703 32.4844C9.45703 45.1174 19.7873 55.3945 32.4844 55.3945C34.375 55.3945 36.2418 55.1647 38.0545 54.712L38.1089 54.6985L38.0978 54.6436C37.9134 53.7311 37.8164 52.7869 37.8164 51.8203C37.8164 44.0986 44.0986 37.8164 51.8203 37.8164C52.7869 37.8164 53.7311 37.9134 54.6436 38.0978ZM51.8203 62.543C57.6332 62.543 62.543 57.6332 62.543 51.8203C62.543 45.9718 57.7323 41.2148 51.8203 41.2148C45.9724 41.2148 41.2148 45.9724 41.2148 51.8203C41.2148 57.7323 45.9718 62.543 51.8203 62.543Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117188
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2166 57.9716L39.1957 57.9282L39.149 57.9403C36.9825 58.5063 34.7477 58.793 32.4844 58.793C17.9129 58.793 6.05859 46.9906 6.05859 32.4844C6.05859 17.9424 17.941 6.05859 32.4844 6.05859C46.9906 6.05859 58.793 17.9129 58.793 32.4844C58.793 34.7478 58.5063 36.9825 57.9403 39.149L57.9282 39.1957L57.9716 39.2166C62.6851 41.4882 65.9414 46.2843 65.9414 51.8203C65.9414 59.5611 59.5629 65.9414 51.8203 65.9414C46.2844 65.9414 41.4883 62.6851 39.2166 57.9716ZM54.6436 38.0978L54.6985 38.1089L54.712 38.0546C55.1649 36.2418 55.3945 34.375 55.3945 32.4844C55.3945 19.7873 45.1174 9.45703 32.4844 9.45703C19.787 9.45703 9.45703 19.787 9.45703 32.4844C9.45703 45.1174 19.7873 55.3945 32.4844 55.3945C34.375 55.3945 36.2418 55.1647 38.0545 54.712L38.1089 54.6985L38.0978 54.6436C37.9134 53.7311 37.8164 52.7869 37.8164 51.8203C37.8164 44.0986 44.0986 37.8164 51.8203 37.8164C52.7869 37.8164 53.7311 37.9134 54.6436 38.0978ZM51.8203 62.543C57.6332 62.543 62.543 57.6332 62.543 51.8203C62.543 45.9718 57.7323 41.2148 51.8203 41.2148C45.9724 41.2148 41.2148 45.9724 41.2148 51.8203C41.2148 57.7323 45.9718 62.543 51.8203 62.543Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117188
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7852 13.207H34.1836V16.6055H30.7852V13.207Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117188
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7852 48.3633H34.1836V51.7617H30.7852V48.3633Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117188
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6488 20.0559L20.0515 17.6532L22.4542 20.0559L20.0515 22.4586L17.6488 20.0559Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.11717
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6454 44.9128L20.048 42.5101L22.4507 44.9128L20.048 47.3155L17.6454 44.9128Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.11717
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5052 20.0559L44.9079 17.6532L47.3106 20.0559L44.9079 22.4586L42.5052 20.0559Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.11717
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.207 30.7852H16.6055V34.1836H13.207V30.7852Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117188
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3633 30.7852H51.7617V34.1836H48.3633V30.7852Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117188
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1836 30.7266V30.7852H34.2422H41.2148V34.1836H30.7852V20.2383H34.1836V30.7266Z",
    fill: "black",
    stroke: "#161614",
    strokeWidth: 0.117188
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.789 50.577L45.3032 53.0628L50.0617 57.8214L58.3359 49.5472L55.8501 47.0613L50.0617 52.8496L47.789 50.577Z",
    fill: "#F30002"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52C66 60.0081 59.5081 66.5 51.5 66.5C43.4919 66.5 37 60.0081 37 52C37 43.9919 43.4919 37.5 51.5 37.5C59.5081 37.5 66 43.9919 66 52ZM41.2877 52C41.2877 57.6401 45.8599 62.2123 51.5 62.2123C57.1401 62.2123 61.7123 57.6401 61.7123 52C61.7123 46.3599 57.1401 41.7877 51.5 41.7877C45.8599 41.7877 41.2877 46.3599 41.2877 52Z",
    fill: "#F30002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTime);
export default __webpack_public_path__ + "static/media/on-time.1b3037d22227e8c0218aedee7c96ec4a.svg";
export { ForwardRef as ReactComponent };